import angular from 'angular';

import appcuesRun from './appcues.run';

export default angular.module('app.appcues', [

])
.run(appcuesRun);
